//駅探APIのファンクション

import { RouteItem, LowestInfo } from '../models/RouteItem'
import { ErrorLog } from '../models/ErrorLog'
import { MsgConst } from '../scripts/MsgConst'
import { StringUtil } from '../scripts/StringUtil'
import { Const } from '../scripts/Const'
import { CostRouteSearchCondition, TrainPassRouteSearchCondition } from '../models/EkitansearchCondition'
import axios, { AxiosError, AxiosInstance, AxiosRequestConfig, CancelTokenSource } from 'axios'
import store from '../store'

//#region axiosにトークンを設定 
// Full config:  https://github.com/axios/axios#request-config
// axios.defaults.baseURL = process.env.baseURL || process.env.apiUrl || '';
// axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

const config = {
    // baseURL: process.env.baseURL || process.env.apiUrl || ""
    // timeout: 60 * 1000, // Timeout
    // withCredentials: true, // Check cross-site Access-Control
}

// tslint:disable-next-line: variable-name
const $axios = axios.create(config)

$axios.interceptors.request.use(function (config) {

    let token = "";
    if (store.state.userToken) {
        token = store.state.userToken
    } else {
        const sessionStrage = sessionStorage.getItem('SampleApp')
        if (sessionStrage) {
            const strageData = JSON.parse(sessionStrage);
            if (strageData.userToken) token = strageData.userToken;
        }
    }
    if (token) {
        config.headers.Authorization = "Bearer " + token
    }
    return config
})
//#endregion

//#region 変数

//駅情報
interface Station {
    text: string;
    cd: string;
    message: string;
}

//キャンセルトークン
let cancelTokenSource: CancelTokenSource | null = null;

//エラーログ設定情報
let errorLog: ErrorLog = new ErrorLog();

//#endregion

interface LogData {
    timeStamp: string;
    requestUrl: string;
    message: string;
    code: string;
    stack: string;
    responseStatus: string;
    responseData: string;
    responseHeaders: string;
    request: string;
    config: string;
}

//#region 外部関数

//#region 駅候補を入力予測候補として取得
const minInterval: number = 200; // ミリ秒
let searchTimeout: number | null = null;

export async function handleSearchStation(station: string, busOption: number, targetDate: string): Promise<Station[]> {

    // 新しい入力で前のタイムアウトをクリア
    if (searchTimeout !== null) {
        clearTimeout(searchTimeout);
    }

    let stationList: Promise<Station[]>;

    stationList = new Promise((resolve) => {
        // 66ミリ秒後に検索を実行するタイムアウトを設定
        searchTimeout = window.setTimeout(async () => {

            //検索実行
            const results = await searchStation(station, busOption, targetDate);
            resolve(results);

        }, minInterval);

        // タイムアウトがクリアされた場合に空の結果を返す
        if (searchTimeout === null) {
            resolve([]);
        }

    });

    return stationList;

}
//#endregion

//#region 駅を取得する
export async function search1stStation(station: string, busOption: number, targetDate: string): Promise<Station> {

    let suggestStation: Station = {
        text: '',
        cd: '',
        message: '',
    };
    let suggestStationList: Station[] = [];
    const params = setParamsForStation(station, busOption, targetDate);
    const baseUrl = process.env.VUE_APP_EKITAN_API_STATION_URL;
    const requestUrl = `${baseUrl}?${new URLSearchParams(params).toString()}`;
    try {

        const response = await axios.get(baseUrl, { params: params, timeout: 10000})
        let listNo = 0;

        //正常に取得できた場合
        if (response.data?.trainDoc?.stationSelectionList?.candidateStationList !== undefined) {

            response.data.trainDoc.stationSelectionList.candidateStationList.forEach((candidateStation: any) => {

                candidateStation.station.forEach((station: any) => {

                    if (candidateStation["~A"].fromOrTo === 'from') {

                        suggestStationList.push({
                            text: station.stationName["~T"],
                            cd: station["~A"].code,
                            message: '',
                        })
                        listNo++;
                    }
                });
            });
        }

        //候補駅を1件以上取得できた場合
        if (listNo > 0) {
            suggestStation.cd = suggestStationList[0].cd
            suggestStation.text = suggestStationList[0].text

            return suggestStation;
        }

        return suggestStation;

    } catch (e) {
        console.log(e.message);

        let message = '';
        if (!axios.isCancel(e)) {
            //サーバーにログ出力
            message = await handleError(e, 'search1stStation', requestUrl);
        }

        //エラー時の取得結果を設定
        suggestStationList.push({
            text: '',
            cd: '',
            message: message,
        })
        return suggestStation;
    }
}
//#endregion

//#region 経費明細用に経路を取得する
export async function searchRouteForCost(condition: CostRouteSearchCondition): Promise<RouteItem[]> {

    const params = setParamsForCost(condition, condition.passKey1);

    return getRouteForCost(condition, params);
}
//#endregion

//#region 経費明細用に経路を取得する(定期未購入・通勤経路)
export async function searchRouteForCostCommmuteRoute(condition: CostRouteSearchCondition): Promise<RouteItem[]> {

    
    let route1: RouteItem[] = []
    let route2: RouteItem[] = []
    let route3: RouteItem[] = []

    let margedRoute: RouteItem[] = [];

    //経路１のみ登録の場合
    if (condition.passKey1 && !condition.passKey2 && condition.commuteRouteKbn === Const.TransPortCost.commuteRouteKbn.INSIDE) {
        const params1 = setParamsForCost(condition, condition.passKey1);
        route1 = await getRouteForCost(condition, params1);
    }//経路2まで登録の場合
    if (condition.passKey2 && !condition.passKey3 && condition.commuteRouteKbn === Const.TransPortCost.commuteRouteKbn.INSIDE) {
        const params1 = setParamsForCost(condition, condition.passKey1);
        const params2 = setParamsForCost(condition, condition.passKey2);
        [route1, route2] = await Promise.all([getRouteForCost(condition, params1), getRouteForCost(condition, params2)]);
    }
    //経路３まで登録の場合
    if (condition.passKey3 && condition.commuteRouteKbn === Const.TransPortCost.commuteRouteKbn.INSIDE) {
        const params1 = setParamsForCost(condition, condition.passKey1);
        const params2 = setParamsForCost(condition, condition.passKey2);
        const params3 = setParamsForCost(condition, condition.passKey3);
        [route1, route2, route3] = await Promise.all([getRouteForCost(condition, params1), getRouteForCost(condition, params2), getRouteForCost(condition, params3)]);
    }

    margedRoute = mergeAndRemoveDuplicates([route1, route2, route3], 'passInfo', condition)

    return margedRoute
}
//#endregion

//#region 経費明細用に最安値情報を取得する
export async function searchLowestForCost(condition: CostRouteSearchCondition): Promise<{ passInfo: string; price: number; message: string; }> {

    let routes: RouteItem[] = []

    //経由駅を取得条件から除外（乗車駅ー下車駅間の最安値を求めるため）
    condition.transitStationCd = '';
    //最安値取得時は優先順を料金順で取得
    condition.orderKbn = Const.TransPortCost.orderKbn.AMOUNT;

    const params = setParamsForCost(condition, condition.passKey1);

    //取得実行
    routes = await getRouteForCost(condition, params);

    let lowestRouteInfo: LowestInfo = { passInfo: '', price: 0, message: '' };

    if (routes.length > 0) {

        lowestRouteInfo.passInfo = routes[0].passInfo;
        lowestRouteInfo.price = routes[0].exceptCommuterFare;

        //エラーメッセージが存在する場合
        if (routes[0].message) {
            lowestRouteInfo.message = routes[0].message;
        }
    }

    return lowestRouteInfo;
}
//#endregion

//#region 定期申請用に最安値情報を取得する
export async function searchLowestForPass(condition: TrainPassRouteSearchCondition): Promise<LowestInfo> {
    let routes: RouteItem[] = []
    //経由駅を取得条件から除外（乗車駅ー下車駅間の最安値を求めるため）
    condition.transitStationCd = '';

    const params = setParamsForTrainPass(condition);

    routes = await getRouteForPass(condition, params);

    let lowestRouteInfo: LowestInfo = { passInfo: '', price: 0, message: '' };

    if (routes.length > 0) {

        lowestRouteInfo.passInfo = routes[0].passInfo;
        lowestRouteInfo.price = routes[0].exceptCommuterFare;

        //エラーメッセージが存在する場合
        if (routes[0].message) {
            lowestRouteInfo.message = routes[0].message;
        }
    }

    return lowestRouteInfo;
}
//#endregion

//#region 定期申請用に経路を取得する
export async function searchRouteForTrainPass(condition: TrainPassRouteSearchCondition): Promise<RouteItem[]> {

    const params = setParamsForTrainPass(condition);

    return getRouteForPass(condition, params);
}
//#endregion

//#endregion

//#region 内部関数

//#region 駅候補を取得
async function searchStation(station: string, busOption: number, targetDate: string): Promise<Station[]> {

    let suggestStationList: Station[] = [];

    // 前のリクエストが存在する場合はキャンセル
    if (cancelTokenSource) {
        cancelTokenSource.cancel();
    }

    // 新しいキャンセルトークンを作成
    cancelTokenSource = axios.CancelToken.source();
    const params = setParamsForStation(station, busOption, targetDate);
    const baseUrl = process.env.VUE_APP_EKITAN_API_STATION_URL;
    const requestUrl = `${baseUrl}?${new URLSearchParams(params).toString()}`;

    try {

        const response = await axios.get(baseUrl, { params: params, timeout: 10000, cancelToken: cancelTokenSource.token})

        //正常に取得できなかった場合
        if (Number(response.data.trainDoc["~A"].status) > 7 && (station || '').trim() !== '') {
            //駅探APIエラーの場合、エラーデータを作成し親画面へ返す
            return createEkitanStationErrordata(response, 'searchStation')
        }

        if (response.data?.trainDoc?.stationSelectionList?.candidateStationList !== undefined) {

            response.data.trainDoc.stationSelectionList.candidateStationList.forEach((candidateStation: any) => {
                let listNo = 0;

                candidateStation.station.forEach((station: any) => {

                    if (candidateStation["~A"].fromOrTo === 'from') {


                        suggestStationList.push({
                            text: station.stationName["~T"],
                            cd: station["~A"].code,
                            message: '',
                        })
                        listNo++;
                    }
                });
                return suggestStationList;
            });
        }
        return suggestStationList;

    } catch (e) {
        console.log(e.message);

        let message = '';
        if (!axios.isCancel(e)) {
            message = await handleError(e, 'searchStation', requestUrl);
        }
        suggestStationList.push({
            text: '',
            cd: '',
            message: message,
        })
        return suggestStationList;
    }
}
//#endregion

//#region 経費経路を取得する
async function getRouteForCost(condition: CostRouteSearchCondition, paramCost: any): Promise<RouteItem[]> {
    let routes: RouteItem[] = [];
    const baseUrl = process.env.VUE_APP_EKITAN_API_ROUTE_URL;
    //APIパラメータ設定
    const params = paramCost;
    const requestUrl = `${baseUrl}?${new URLSearchParams(params).toString()}`;
    
    try {
        const response = await axios.get(baseUrl, { params: params, timeout: 10000})

        //正常に取得できなかった場合
        if (response.data.trainDoc["~A"].status !== '0') {
            //駅探APIエラーの場合、エラーデータを作成し親画面へ返す
            return createEkitanErrordata(response, 'searchRouteForCost', requestUrl)
        }
        //レスポンスデータをもとに交通費経路一覧作成
        routes = createCostRoutes(response, condition);

        //経路が存在する場合
        if (routes.length > 0) {

            //料金順
            if (condition.orderKbn === Const.TransPortCost.orderKbn.AMOUNT) {

                routes.sort((a, b) => a.exceptCommuterFare - b.exceptCommuterFare);

            }
            //時間順
            else if (condition.orderKbn === Const.TransPortCost.orderKbn.TIME) {

                routes.sort((a, b) => convertToMinutes(a.time) - convertToMinutes(b.time));
            }

            return routes;
        }

        return routes;

    } catch (e) {
        console.log(e.message)
        let message = '';
        if (!axios.isCancel(e)) {
            message = await handleError(e, 'searchRouteForCost', requestUrl);
        }
        routes.push({
            no: 0,
            passInfo: '',
            time: '',
            exceptCommuterFare: 0,
            commuterRegistKey: '',
            check: false,
            message: message,
            //通勤経路かどうか
            ifCommuteRoute: false
        })

        return routes;
    }

}
//#endregion

//#region　定期経路を取得する
async function getRouteForPass(condition: TrainPassRouteSearchCondition, paramTrainPass: any): Promise<RouteItem[]> {

    let routes: RouteItem[] = [];
    const params = paramTrainPass;
    const baseUrl = process.env.VUE_APP_EKITAN_API_ROUTE_URL;
    const requestUrl = `${baseUrl}?${new URLSearchParams(params).toString()}`;
    
    try {

        const response = await axios.get(baseUrl, { params: params, timeout: 10000 })

        if (response.data.trainDoc["~A"].status !== '0') {
            //駅探APIエラーの場合、エラーデータを作成し親画面へ返す
            return createEkitanErrordata(response, 'getRouteForPass', requestUrl)
        }

        //レスポンスデータをもとに経路一覧を作成
        routes =  createTrainPassRoutes(response);

        if (routes.length > 0) {

            //料金順に並び変える
            routes.sort((a, b) => a.exceptCommuterFare - b.exceptCommuterFare);

            return routes;
        }

        return routes;

    } catch (e) {

        console.log(e.message)

        //サーバーにエラーログ出力
        let message = '';
        if (!axios.isCancel(e)) {
            message = await handleError(e, 'getRouteForPass', requestUrl);
        }
        //エラー時の取得結果を設定
        routes.push({
            no: 0,
            //経路
            passInfo: '',
            //所要時間
            time: '',
            //定期運賃
            exceptCommuterFare: 0,
            //定期区間コード
            commuterRegistKey: '',
            //選択（未選択）
            check: false,
            //メッセージ（エラー発生時）
            message: message,
            //通勤経路かどうか
            ifCommuteRoute: false
        })

        return routes;
    }
}

//#endregion

//#region　時：分　を分に変換
function convertToMinutes(time: string): number {
    const [hours, minutes] = time.split(':').map(Number);
    return hours * 60 + minutes;
}

//#endregion

//#region　エラーハンドリング
async function handleError(error: unknown, functionNm: string, requestUrl: string): Promise<string> {

    let message = '';

    const logData: ErrorLog = {
        timeStamp: new Date().toISOString(),
        requestUrl: requestUrl,
        functionNm: functionNm,
        empCd:'',
        message: '',
        code: '',
        stack: '',
        responseStatus: '',
        responseData: '',
        responseHeaders: '',
        request: '',
        config: '',
        errorType:'',
    };

    if (axios.isAxiosError(error)) {
        //axiosエラーの場合

        logData.message = error.message || '';
        logData.code = error.code || '';
        logData.stack = error.stack || '';
        logData.errorType = translateErrorMessage(error);

        if (error.response) {
            //レスポンスあり
            logData.responseStatus = error.response.status.toString() || '';
            logData.responseData = JSON.stringify(error.response.data) || '';
            logData.responseHeaders = JSON.stringify(error.response.headers) || '';
        } else if (error.request) {
            //リクエストあり　応答なし
            logData.request = JSON.stringify(error.request) || 'No response received';
        }
    } else if (error instanceof Error) {
        //設定エラー　その他
        logData.message = error.message || 'Unknown error';
        logData.stack = error.stack || '';
        if (!logData.errorType) {
            logData.errorType = '不明なエラー';
        }
    }
    //共通メッセージを設定
    message = MsgConst.EKITAN.ERROR_001;
    //個別メッセージを設定
    message += '\r\n' + logData.errorType;

    logData.config = JSON.stringify((error as AxiosError).config) || '';
    const data = {
        ErrorLog: logData
    }
    //サーバーににエラーログを出力
    await $axios.post('api/TrainPassApplication/writeErrorLog', data)

    return message;
}

//#endregion

//#region   駅探ステータス異常時のデータ作成（駅候補）
function createEkitanStationErrordata(response: any, functionName: string) {
    let station: Station[] = [];

    //エラーの場合のログ情報を作成
    errorLog.responseStatus = (response.status).toString()
    errorLog.responseData = JSON.stringify(response.data);
    errorLog.functionNm = functionName
    switch (response.data.trainDoc["~A"].status) {
        case '200':
            errorLog.message = Const.EkitanStatus.STATUSNM_200
            break;
        //パラメータ指定エラー
        case '100':
            errorLog.message = Const.EkitanStatus.STATUSNM_100
            break;
        case '220':
            errorLog.message = Const.EkitanStatus.STATUSNM_220
            break;
        default:
            errorLog.message = Const.EkitanStatus.STATUSNM_DEFAULT
            break;
    }

    const data = {
        ErrorLog: errorLog
    }

    //サーバーへエラーログを書き込む
    $axios.post('api/TrainPassApplication/writeErrorLog', data)

    //親画面へエラーデータを返す
    station.push({
        text: '',
        cd: '',
        message: StringUtil.stringFormat(MsgConst.EKITAN.ERROR_002, errorLog.message),
    })

    return station;
}
//#endregion

//#region 駅探ステータス異常時のデータを作成
function createEkitanErrordata(response: any, functionName: string, requestUrl :string) {
    let routes: RouteItem[] = [];

    //エラーの場合のログ情報を作成
    errorLog.responseStatus = (response.status).toString()
    errorLog.responseData = JSON.stringify(response.data);
    errorLog.functionNm = functionName;
    errorLog.requestUrl = requestUrl;
    switch (response.data.trainDoc["~A"].status) {
        //正常
        case '0':
            break;
        //SF指定エラー
        case '1':
            errorLog.message = Const.EkitanStatus.STATUSNM_1
            break;
        //ST指定エラー
        case '2':
            errorLog.message = Const.EkitanStatus.STATUSNM_2
            break;
        case '3':
            errorLog.message = Const.EkitanStatus.STATUSNM_3
            break;
        case '4':
            errorLog.message = Const.EkitanStatus.STATUSNM_4
            break;
        //SVn指定エラー
        case '7':
            errorLog.message = Const.EkitanStatus.STATUSNM_7
            break;
        case '200':
            errorLog.message = Const.EkitanStatus.STATUSNM_200
            break;
        //パラメータ指定エラー
        case '100':
            errorLog.message = Const.EkitanStatus.STATUSNM_100
            break;
        case '220':
            errorLog.message = Const.EkitanStatus.STATUSNM_220
            break;
        default:
            errorLog.message = Const.EkitanStatus.STATUSNM_DEFAULT
            break;
    }

    const data = {
        ErrorLog: errorLog
    }

    //サーバーへエラーログを書き込む
    $axios.post('api/TrainPassApplication/writeErrorLog', data)

    //親画面へエラーデータを返す
    routes.push({
        no: 0,
        passInfo: '',
        time: '',
        exceptCommuterFare: 0,
        commuterRegistKey: '',
        check: false,
        message: StringUtil.stringFormat(MsgConst.EKITAN.ERROR_002, errorLog.message),
        //通勤経路かどうか
        ifCommuteRoute: false
    })

    return routes;
}
//#endregion

//#region 定期経路リスト作成
function createTrainPassRoutes(response: any): RouteItem[]{
    let routes: RouteItem[] = [];
    let no = 1
    let lineString = ''
    let fareIC = 0
    let registKey = ''
    if (response.data?.trainDoc?.routeList?.route !== undefined) {
        response.data.trainDoc.routeList.route.forEach((route: any) => {

            let lineNo = 1
            route.lineList.line.forEach((line: any) => {
                //経路文字列を作成する
                if (lineNo == 1) {
                    lineString = lineString + line.stationFrom.stationName["~T"] + ' - ' + '[' + line.lineName["~T"] + ']' + '-' + line.stationTo.stationName["~T"]
                } else {
                    lineString = lineString + ' - ' + '[' + line.lineName["~T"] + ']' + '-' + line.stationTo.stationName["~T"]
                }
                lineNo++
            });

            //定期区間コードを取得できない経路の場合は一覧に出力しない
            if ((route?.commuterFareList?.[0]?.commuterFare?.[0]?.fare?.["~T"] !== undefined) || route?.commuterFareList?.[0]?.commuterRegistKey?.["~T"] !== undefined) {

                fareIC = route.commuterFareList[0].commuterFare[0].fare["~T"];
                registKey = route.commuterFareList[0].commuterRegistKey["~T"];

                //取得結果を設定
                routes.push({
                    no: no,
                    //経路
                    passInfo: lineString,
                    time: route.time.hour["~T"].padStart(2, '0') + ':' + route.time.min["~T"].padStart(2, '0'),
                    //所要
                    exceptCommuterFare: fareIC,
                    //定期運賃
                    commuterRegistKey: registKey,
                    //経路区間コード
                    check: false,
                    //選択（未選択）
                    message: '',
                    //通勤経路かどうか
                    ifCommuteRoute: false
                    //メッセージ（エラー発生時）
                })
            }

            lineString = ''
            no++;
        });
    }
    return routes;
}
//#endregion

//#region　交通費経路リスト作成
function createCostRoutes(response: any, condition: CostRouteSearchCondition): RouteItem[] {
    let routes: RouteItem[] = [];
    let no = 1
    let lineString = ''
    //定期経路かどうか
    let commuteRoute: boolean = false;

    response.data.trainDoc.routeList.route.forEach((route: any) => {

        let lineNo = 1
        let registKey = ''
        let basicFare = 0

        //経路　文字列を作成する
        route.lineList.line.forEach((line: any) => {

            if (lineNo == 1) {
                lineString = lineString + line.stationFrom.stationName["~T"] + ' - ' + '[' + line.lineName["~T"] + ']' + '-' + line.stationTo.stationName["~T"]
            } else {
                lineString = lineString + ' - ' + '[' + line.lineName["~T"] + ']' + '-' + line.stationTo.stationName["~T"]
            }
            lineNo++
        });

        //バス含む経路の場合、定期区間コードは空白とする
        if (route.commuterFareList?.[0]?.commuterRegistKey?.["~T"] !== undefined) {
            registKey = route.commuterFareList[0].commuterRegistKey["~T"];
        } else {
            registKey = '';
        }

        if (condition.trainPassPurchaseFlg === true) {
            //定期購入の場合　定期を考慮した金額を出力
            basicFare = Number(route.exceptCommuterBasicFareIc["~T"]);
        } else if (condition.commuteRouteKbn == Const.TransPortCost.commuteRouteKbn.INSIDE) {
            //定期未購入・通勤経路の場合、定期を考慮しない金額を出力
            basicFare = Number(route.basicFareIc["~T"]);
        } else {
            //定期未購入・通勤経路外の場合、定期を考慮した金額を出力
            basicFare = Number(route.exceptCommuterBasicFareIc["~T"]);
        }

        //往復を選択の場合、金額を2倍に設定
        if (condition.roundKbn == '02') {
            basicFare = basicFare * 2;
        } else {
            basicFare = basicFare;
        }

        //定期考慮運賃が０の場合、TRUE
        if (Number(route.exceptCommuterBasicFareIc["~T"]) === 0) {
            commuteRoute = true;
        }

        routes.push({
            no: no,
            //経路
            passInfo: lineString,
            //所要時間
            time: route.time.hour["~T"].padStart(2, '0') + ':' + route.time.min["~T"].padStart(2, '0'),
            //運賃
            exceptCommuterFare: basicFare,
            //経路区間コード
            commuterRegistKey: registKey,
            //選択（未選択）
            check: false,
            //メッセージ（エラー発生時）
            message: '',
            //通勤経路かどうか
            ifCommuteRoute: commuteRoute
        })

        commuteRoute = false
        lineString = ''
        no++;
    });
    return routes;
}
//#endregion

//#region エラータイプ設定
function translateErrorMessage(error: AxiosError): string {
    if (error.response) {
        switch (error.response.status) {
            case 400:
                return 'クライアントエラー: 不正なリクエスト';
            case 401:
                return '認証エラー: 認証が必要です';
            case 403:
                return '認可エラー: アクセスが拒否されました';
            case 404:
                return 'クライアントエラー: リソースが見つかりません';
            case 500:
                return 'サーバーエラー: 内部サーバーエラー';
            default:
                return `サーバーエラー: ステータスコード ${error.response.status}`;
        }
    } else if (error.request) {
        return 'リクエストエラー: サーバーからの応答がありません';
    } else {
        switch (error.code) {
            case 'ECONNABORTED':
                return 'ネットワークエラー: リクエストがタイムアウトしました';
            case 'ERR_NETWORK':
                return 'ネットワークエラー: ネットワークに接続できません';
            case 'ERR_BAD_REQUEST':
                return '設定エラー: 不正なリクエスト';
            case 'ERR_BAD_RESPONSE':
                return 'サーバーエラー: 不正な応答';
            case 'ERR_CANCELED':
                return 'リクエストエラー: リクエストがキャンセルされました';
            case 'ERR_FR_TOO_MANY_REDIRECTS':
                return 'リクエストエラー: リダイレクトが多すぎます';
            case 'ERR_DEPRECATED':
                return '設定エラー: 非推奨の機能が使用されました';
            default:
                return `設定エラー: ${error.message}`;
        }
    }
}
//#endregion

//#region　経費経路検索　APIパラメータを設定する
function setParamsForCost(condition: CostRouteSearchCondition, CS: string) {

    //パラメータ初期設定
    const params = {
        //乗車駅
        SF: condition.startStationCd,
        //下車駅
        ST: condition.endStationCd,
        //経由駅
        SV1: condition.transitStationCd,
        //検索対象日
        DT: condition.targetDate,
        //時間。半角数字4桁(hhmm)の数字
        TM: condition.targetTime,
        //路線バス指定
        RB: Const.TransPortCost.busOption.INCLUDE,
        //定期申請情報
        CS: CS,
        LANG: process.env.VUE_APP_EKITAN_DEFAULT_PARAM_LANG,
        //IC運賃表示形式
        ICF: Const.EkitanURLParam.Norikae.ICF.PR_2,
        //文字コード
        CHAR: Const.EkitanURLParam.Norikae.CHAR.UTF_8,
        //乗り換え時間指定
        TP: Const.EkitanURLParam.Norikae.TP.STANDARD,
        //優先指定
        RP: Const.EkitanURLParam.Norikae.RP.OUTSIDE_COMMUTER_PASS,
        //短距離有料特急有無
        EP: Const.EkitanURLParam.Norikae.EP.PRESENCE,
        //航空会社優先指定
        AIR: Const.EkitanURLParam.Norikae.AIR.NONE,
        //IC料金表示形式
        ICC: Const.EkitanURLParam.Norikae.ICC.OUTPUT,
        //発着指定
        SR: Const.EkitanURLParam.Norikae.SR.DEPARTURE,
        //行き先表示指定
        BS: Const.EkitanURLParam.Norikae.BS.DISPLAY,
        //エリア番号
        AN: Const.EkitanURLParam.Norikae.AN.JAPAN_NATIONAL,
        //定期運賃計算 
        CP: Const.EkitanURLParam.Norikae.CP.OUTPUT,
        //略称の有無
        NF: Const.EkitanURLParam.Norikae.NF.FULL_NAME,
        //出力形式指定
        OF: Const.EkitanURLParam.Norikae.OF.JSON,
    }; // パラメータを設定

    //定期購入　なし
    if (condition.trainPassPurchaseFlg === false) {

        if (condition.commuteRouteKbn === Const.TransPortCost.commuteRouteKbn.INSIDE) {
            //通勤経路の場合、定期経路区間コードを設定
            params.CS = CS            
        } else if (condition.commuteRouteKbn === Const.TransPortCost.commuteRouteKbn.OUTSIDE) {
            //通期経路外の場合、定期経路区間コードを空に設定
            params.CS = '';
        }
    }

    return params;
}
//#endregion

//#region 定期経路検索パラメータ検索
function setParamsForTrainPass(condition: TrainPassRouteSearchCondition) {
    const params = {
        LANG: process.env.VUE_APP_EKITAN_DEFAULT_PARAM_LANG,
        //乗車駅
        SF: condition.startStationCd,
        //下車駅
        ST: condition.endStationCd,
        //経由駅
        SV1: condition.transitStationCd,
        //検索対象日
        DT: condition.targetDate,
        //時間。半角数字4桁(hhmm)の数字
        TM: condition.targetTime,
        //路線バス指定
        RB: Const.TransPortCost.busOption.EXCLUDE,
        //IC運賃表示形式
        ICF: Const.EkitanURLParam.Norikae.ICF.PR_2,
        //文字コード
        CHAR: Const.EkitanURLParam.Norikae.CHAR.UTF_8,
        //乗り換え時間指定
        TP: Const.EkitanURLParam.Norikae.TP.STANDARD,
        //優先指定
        RP: Const.EkitanURLParam.Norikae.RP.COMMUTER_PASS,
        //短距離有料特急有無
        EP: Const.EkitanURLParam.Norikae.EP.NONE,
        //航空会社優先指定
        AIR: Const.EkitanURLParam.Norikae.AIR.NONE,
        //IC料金表示形式
        ICC: Const.EkitanURLParam.Norikae.ICC.OUTPUT,
        //発着指定
        SR: Const.EkitanURLParam.Norikae.SR.DEPARTURE,
        //行き先表示指定
        BS: Const.EkitanURLParam.Norikae.BS.DISPLAY,
        //エリア番号
        AN: Const.EkitanURLParam.Norikae.AN.JAPAN_NATIONAL,
        //定期運賃計算 
        CP: Const.EkitanURLParam.Norikae.CP.OUTPUT,
        //略称の有無
        NF: Const.EkitanURLParam.Norikae.NF.FULL_NAME,
        //出力形式指定
        OF: Const.EkitanURLParam.Norikae.OF.JSON,
    }
    return params;
}
//#endregion

//#region 駅候補検索　パラメータ設定
function setParamsForStation(station: string, busOption: number, targetDate: string) {
    const params = {
        //乗車駅
        SF: station,　//すべて乗車駅として検索してよい
        //路線バス指定
        RB: busOption.toString(),
        //検索対象日
        DT: targetDate,
        //エリア番号
        AN: Const.EkitanURLParam.NorikaeSearchStation.AN.JAPAN_NATIONAL,
        //文字コード
        CHAR: Const.EkitanURLParam.NorikaeSearchStation.CHAR.UTF_8,
        //略称の有無
        NF: Const.EkitanURLParam.NorikaeSearchStation.NF.FULL_NAME,
        //複合名称出力
        CO: Const.EkitanURLParam.NorikaeSearchStation.CO.NOT_OUTPUT,
        //出力形式指定
        OF: Const.EkitanURLParam.NorikaeSearchStation.OF.JSON,
    };

    return params;
}
//#endregion

//#region ３つの検索結果を統合する
function mergeAndRemoveDuplicates<RouteItem extends { [key: string]: any }>(lists: RouteItem[][], key: keyof RouteItem, condition: CostRouteSearchCondition): RouteItem[] {
    const mergedList = lists.flat();
    const uniqueList: RouteItem[] = [];
    const seenKeys = new Set<RouteItem[keyof RouteItem]>();

    //定期経路を先頭にする
    mergedList.sort((a, b) => b.ifCommuteRoute - a.ifCommuteRoute);

    //経路が重複する場合、リスト後方を削除
    for (const item of mergedList) {
        if (!seenKeys.has(item[key])) {
            seenKeys.add(item[key]);
            uniqueList.push(item);
        }
    }

    if (condition.orderKbn === Const.TransPortCost.orderKbn.AMOUNT) {

        //料金順
        uniqueList.sort((a, b) => b.ifCommuteRoute - a.ifCommuteRoute);

    }
    else if (condition.orderKbn === Const.TransPortCost.orderKbn.TIME) {
        //時間順
        uniqueList.sort((a, b) => convertToMinutes(a.time) - convertToMinutes(b.time));
    }
    //定期経路を先頭にする
    uniqueList.sort((a, b) => a.exceptCommuterFare - b.exceptCommuterFare);

    return uniqueList;
}
//#endregion

//#endregion
